import React, { PureComponent } from 'react';

import { Dropdown } from 'components/ClubComponents';
import { translate } from 'components/translate';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';

const OMITTED_PROPS = ['action', 't'];

@translate()
class BulkActionsDropdownItem extends PureComponent {
  static propTypes = {
    action: PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      handler: PropTypes.func
    }).isRequired,
    t: PropTypes.func
  };

  constructor(props) {
    super(props);

    const { action, t } = props;

    this.item = {
      id: action.label,
      label: t(`${action.label}`),
      icon: action.icon,
      onClick: action.handler
    };
  }

  render() {
    const { action, ...others } = this.props;

    return (
      <Dropdown.Item
        {...omit(others, OMITTED_PROPS)}
        id={action.label}
        item={this.item}
      />
    );
  }
}

export default BulkActionsDropdownItem;
